import * as yup from 'yup';

export interface PickupPointFormValues {
  city: string;
  address: string;
  metro: string;
  metroIconColor: string;
  phoneNumber: string;
  telegram: string;
  email: string;
  lat: string;
  long: string;
}

export const pickupPointModalSchema = yup.object({
  city: yup.string().defined(),
  address: yup.string().trim().required('Укажите адрес'),
  metro: yup.string().defined(),
  metroIconColor: yup.string().defined(),
  phoneNumber: yup
    .string()
    .required('Укажите номер телефона')
    .test(
      'ru-mobile',
      'Введите полный номер в формате +7 (XXX) XXX-XX-XX',
      (value) => /^7[0-9]{10}$/.test((value ?? '').replace(/\D/g, '')),
    )
    .test(
      'ru-mobile-second-digit',
      'Некорректный номер',
      (value) => {
        const digits = (value ?? '').replace(/\D/g, '');
        return digits.length < 2 || digits[1] === '9';
      },
    ),
  telegram: yup.string().defined(),
  email: yup.string().trim().required('Укажите email').email('Введите корректный email'),
  lat: yup.string().defined(),
  long: yup.string().defined(),
}) as yup.ObjectSchema<PickupPointFormValues>;
